/*globals $:false */

import { format as formatNumber } from '../fields/recordm.fields.number.js';

import tmpl_action_btn from '../templates/instance-action-btn.dot';
import tmpl_instance from '../templates/instance-detail.dot';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

// args:
// * `core`: cob.app
// * `$container`: The html container
//
// confs:
// * canEdit: If the user can edit the instance, otherwise all fields will be blocked
// * templateName: the name of the template to use. Defaults to 'tmpl-instance'.
// * exitLabel: a localize key to be used on the exit (back) button
// * saveBehaviors: which save buttons to add to the instance view
//
// callbacks:
// * `collapseAll`: The user requested all fields collapsed
// * `expandAll`: The user requested all fields expanded
// * `exit`: The user requested to exit
// * `save`: The user requested to save the instance
var InstanceV = function(core, $container, confs, callbacks) {
    var _$instanceContainer,
        _$containerWrapper,
        _fieldsContainer,
        _instanceErrorsMsg;

    var _confs = {
        canEdit: true,
        saveBehaviors: []
    };

    utils.extend(_confs, confs, true);

    var _showInstance = function(instanceData) {
        var $html = $(tmpl_instance({...instanceData, i18n: {
           copy_id: core.translateString('recordm.instances', 'action.copy.id'),
           copy_url: core.translateString('recordm.instances', 'action.copy.url')
        }}));

        _fieldsContainer = $html.find(".js-fields");
        _instanceErrorsMsg = $html.find(".js-instance-errors");

        if (_confs.canEdit) {
            const $saveBtnsContainer = $(".js-sidenav-btn-container", $html);
            _confs.saveBehaviors.forEach((behavior) => {
                // fix mode overrides all save button classes
                if(_confs.canFix && core.inFixMode()) behavior.cssClasses = 'btn-danger';
                else if(!behavior.cssClasses) behavior.cssClasses = "btn-success";
                $saveBtnsContainer.append(tmpl_action_btn(behavior))
            });
        }

        if(_confs.exitLabel) {
            $html.find('.js-back span').attr('rel', `localize[${_confs.exitLabel}]`)
        }

        $html.on("click", ".js-copy-id", function(e) {
            e.stopPropagation();
            navigator.clipboard.writeText(instanceData.id).then(function(){
               ui.notification.showInfo(core.translateString('recordm.instances', 'msgs.copy.id'));
            })
        });
        $html.on("click", ".js-copy-link", function(e) {
            e.stopPropagation();
            // on alt+click copy the internal hash uri
            const simpleUrl = (e.altKey ? window.location.hash : window.location.href ).replace(/\?_=.*/,'')
              // replaces ID, because we can be inside a $references and the location points to the parent ID
              .replace(/\d+$/, instanceData.id );
            navigator.clipboard.writeText(simpleUrl).then(() => {
               ui.notification.showInfo(core.translateString('recordm.instances', 'msgs.copy.url'));
            })
        });


        _$containerWrapper.append($html);
        _$instanceContainer.removeClass("hidden");

        core.translate('recordm.instances', $html);
    };

    var _showInstanceForEditInGroup = function(instanceData, totalAffected) {
        _showInstance(instanceData);

        _$instanceContainer.find(".js-single-instance")
            .addClass("hidden");

        _updateEditInGroupTotalAffected(totalAffected);
    };

    const _updateEditInGroupTotalAffected = function(totalAffected) {
        _$instanceContainer.find(".js-group-edit").removeClass("hidden")
            .find(".js-total-affected")
            .text(formatNumber(totalAffected, false, 0, core.getLocale()));
    };

    var _init = function() {
        _$instanceContainer = $('.instance-container', $container);
        _$containerWrapper = $('.js-recordm-instance', _$instanceContainer);

        if (_confs.canEdit) {
            _confs.saveBehaviors.forEach((behavior) => {
                $container.on("click", `.js-${behavior.name}-instance`, function(e) {
                    e.stopPropagation();
                    callbacks.save(behavior.name);
                });
            });
        }

        $container.on("click", ".js-back", function(e) {
            e.stopPropagation();
            callbacks.exit();
        });

        $container.on("click", ".js-collapse-all", function(e) {
            e.stopPropagation();
            callbacks.collapseAll();
        });

        $container.on("click", ".js-expand-all", function(e) {
            e.stopPropagation();
            callbacks.expandAll();
        });

       let logsVisible = false;
       $container.on("click", ".js-logs-button", function() {
          const $fieldsAndLogContainer = $('.fields-container', $container);
          const altura = $fieldsAndLogContainer[0].scrollHeight;

          $('.js-log-wrapper2', $container).toggle();
          logsVisible = !logsVisible;

          if(logsVisible) $fieldsAndLogContainer.animate({
             scrollTop: altura - 50
          }, 1000);
       });
    };

    var _destroy = function() {
        $container.off("click", ".js-back");
        $container.off("click", ".js-save-instance");
        $container.off("click", ".js-collapse-all");
        $container.off("click", ".js-expand-all");
        $container.off("click", ".js-logs-button");
    };

    return{
        init: _init,
        destroy: _destroy,

        showInstance: _showInstance,
        showInstanceForEditInGroup: _showInstanceForEditInGroup,
        updateEditInGroupTotalAffected: _updateEditInGroupTotalAffected,

        addField: function(field) {
            _fieldsContainer.append(field.content());
        },
        addChildField: function(field) {
            _fieldsContainer.append(field.content());
        },
        addFieldAfter: function(field, afterWhom) {
            $(afterWhom.content()).after(field.content());
        },
        addChildFieldAfter: function(field, afterWhom) {
            $(afterWhom.content()).after(field.content());
        },

        showErrorMsg: function() {
            _instanceErrorsMsg.removeClass('hidden');
        },
        clearErrors: function() {
            _instanceErrorsMsg.addClass('hidden');
        },

        disableSaveBtn: function(){
            _confs.saveBehaviors.forEach((behavior) => {
                $(`.js-${behavior.name}-instance`, $container).enable(false);
            });
        },
        enableSaveBtn: function(){
            _confs.saveBehaviors.forEach((behavior) => {
                $(`.js-${behavior.name}-instance`, $container).enable(true);
            });
        },

        autoResizeTextAreas: function() {
            $("textarea", $container).trigger("input");
        },

        addAction: function (action){
            const $btnsContainer = $(".js-sidenav-btn-container", _$instanceContainer);
            const $actionBtn = $(tmpl_action_btn(action));

            $actionBtn.click(function(e) {
                e.stopPropagation();
                action.callback($actionBtn);
            });

            $btnsContainer.append($actionBtn);
        }
    }
};

export default InstanceV;
